import React from 'react';
import Form from './components/Form';
import { FormikProvider } from 'formik';
import { useRaceTableForm } from './services/RaceDetailsTable.hooks';
import { TRaceDetails, TMarket } from '@/lib/DBModels';
import { ERaceMarketType } from '@/features/tradeManager/pages/RaceDetails/Services/RaceDetails.types';

type TRaceDetailsTable = {
  raceData: TRaceDetails;
  raceMarkets?: TMarket[];
  priceType?: ERaceMarketType;
};

export default function RaceDetailsTable({
  raceData,
  raceMarkets,
  priceType,
}: TRaceDetailsTable) {
  const {
    formik,
    data,
    isManuallyManaged,
    onClickRow,
    apiModel,
    priceModifierState,
    priceModifiersDispatch,
    isUpdateButtonEnabled,
    setIsUpdateButtonEnabled,
  } = useRaceTableForm(raceData);

  return (
    <FormikProvider value={formik}>
      <Form
        formik={formik}
        data={data}
        raceMarkets={raceMarkets}
        priceModifierState={priceModifierState}
        priceModifiersDispatch={priceModifiersDispatch}
        isManuallyManaged={isManuallyManaged}
        onClickRow={onClickRow}
        apiModel={apiModel}
        isUpdateButtonEnabled={isUpdateButtonEnabled}
        setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
        priceType={priceType}
      />
    </FormikProvider>
  );
}
